import React from 'react';
import { string, func } from 'prop-types';

import {
  DropdownItem,
  DropdownList,
  DropdownAction,
  DropdownContent,
} from '../../ui-helpers';

import { SvgIcon } from '../../svg-icon';
import { Popconfirm } from '../../popovers';

export const TalentDropdownComp = ({
  _id,
  requestId,
  handleTalentDelete,
}) => (
  <DropdownContent width={200}>
    <DropdownList>
      <DropdownItem>
        <Popconfirm
          title="Are you sure you want to delete this talent?"
          onConfirm={() => handleTalentDelete(requestId, _id)}
        >
          <DropdownAction data-popconfirm-stay-open>
            <SvgIcon type="trash" width={14} />
            Delete
          </DropdownAction>
        </Popconfirm>
      </DropdownItem>
    </DropdownList>
  </DropdownContent>
);


TalentDropdownComp.propTypes = {
  _id: string.isRequired,
  requestId: string.isRequired,
  handleTalentDelete: func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/talents-list/talent-dropdown/index.js